<template>
  <div class="bindPhoneDialog" v-show="visible">
    <div class="content-box">
      <div class="box-close">
        <span class="close-icon" @click="closeDia">x</span>
      </div>
      <div class="box-img">
        <img src="./bangding_icon@2x.png" alt="" />
      </div>
      <div class="box-title">绑定手机号码</div>
      <div class="box-msg">
        <div class="msg">游玩请绑定手机号码</div>
        <div class="msg">应网络安全法相关规定要求</div>
      </div>
      <div class="box-btn" @click="toBing">去绑定</div>
    </div>
  </div>
</template>

<script>
import store from "../../api/store";
export default {
  name: "bindPhoneDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeDia() {
      this.$emit("update:visible", false);
    },
    toBing() {
      this.$emit("update:visible", false);
      window.location.href = store.loginedUser.bindPhoneUrl;
    },
  },
};
</script>

<style scoped>
.bindPhoneDialog {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  color: #333;
}

.content-box {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
}

.content-box .box-close {
  align-self: stretch;
  display: flex;
  justify-content: flex-end;
}

.content-box .box-close span {
  width: 30px;
  height: 30px;
  margin: 5px 5px 0 0;
  line-height: 30px;
  text-align: center;
  font-size: 20px;
  color: #999;
}

.content-box .box-img {
  margin-bottom: 20px;
}

.content-box .box-img img {
  width: 123px;
  height: 70px;
}

.content-box .box-title {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
}

.content-box .box-msg {
  text-align: center;
  margin-bottom: 15px;
  line-height: 1;
}

.content-box .box-msg .msg + .msg {
  margin-top: 10px;
}

.content-box .box-btn {
  width: 80%;
  height: 40px;
  margin: 15px 0 25px 0;
  line-height: 40px;
  text-align: center;
  background-color: #4c97ff;
  border-radius: 20px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/bindPhone/bindPhoneDialog.vue